<template>
  <v-toolbar fixed>
    <v-toolbar-title>Clasificador</v-toolbar-title
    >
    <v-toolbar-breadcrumbs class="ml-2" />
    <v-spacer />
    <v-toolbar-items>
      <v-slide-x-transition>
        <span v-if="currentClassification" style="height: 100%">
          <v-toolbar-class-ranking-button key="ranking" />
          <v-toolbar-filters-button key="filters" />
          <v-toolbar-samples-button key="samples" />
          <v-toolbar-validated-button key="validated" />
        </span>
      </v-slide-x-transition>
      <v-toolbar-settings-menu />
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapState } from "vuex";

import VToolbarBreadcrumbs from "./ToolbarBreadcrumbs";
import VToolbarFiltersButton from "./ToolbarFiltersButton";
import VToolbarClassRankingButton from "./ToolbarClassRankingButton";
import VToolbarSamplesButton from "./ToolbarSamplesButton";
import VToolbarSettingsMenu from "./settings-menu/Layout";
import VToolbarValidatedButton from "./ToolbarValidatedButton";

export default {
  components: {
    VToolbarBreadcrumbs,
    VToolbarClassRankingButton,
    VToolbarFiltersButton,
    VToolbarSamplesButton,
    VToolbarSettingsMenu,
    VToolbarValidatedButton,
  },
  computed: {
    ...mapState("classifier", ["currentClassification"]),
  },
};
</script>
